import { render, staticRenderFns } from "./deleteActivitiesType.vue?vue&type=template&id=0ac253f8&scoped=true"
import script from "./deleteActivitiesType.vue?vue&type=script&lang=js"
export * from "./deleteActivitiesType.vue?vue&type=script&lang=js"
import style0 from "./deleteActivitiesType.vue?vue&type=style&index=0&id=0ac253f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac253f8",
  null
  
)

export default component.exports